import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { isIOS } from 'react-device-detect';

const downloadFile = (href, name) => {
  const element = document.createElement('a');
  document.body.appendChild(element);
  element.setAttribute('href', href);
  element.setAttribute('download', name);

  element.style.display = '';

  element.click();

  document.body.removeChild(element);
};

const downloadBlob = (blobData, name, type) => {
  Promise.resolve(blobData).then(result => {
    const blob = new Blob([result], { type });
    downloadFile(window.URL.createObjectURL(blob), name);
  });
};

class DownloadUrlButton extends Component {
  constructor(props) {
    super(props);

    this.handleDownloadClick = this.handleDownloadClick.bind(this);
  }

  handleDownloadClick(event) {
    const { fileName, fileType, exportFile } = this.props;

    const magicDownload = (blobData, name, type) => {
      if (isIOS) {
        downloadFile(blobData.url, name);
      } else {
        downloadBlob(blobData.blob, name, type);
      }

      event.stopPropagation();
    };

    const data = exportFile();
    Promise.resolve(data).then(result => magicDownload(result, fileName, fileType));
  }

  render() {
    return (
      <Button color="link" onClick={this.handleDownloadClick}>
        {this.props.children}
      </Button>
    );
  }
}

DownloadUrlButton.propTypes = {
  children: PropTypes.node,
  fileName: PropTypes.string,
  fileType: PropTypes.string,
  exportFile: PropTypes.func,
};

DownloadUrlButton.defaultProps = {
  children: 'Download',
};

export default DownloadUrlButton;
